(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["citybee-bluu-home"] && !Shopify.designMode) return;
  try {
    
const initCitybeeSlider = (root) => {
  if (root.dataset.cbInitialized === 'true') return;
  const slides = Array.from(root.querySelectorAll('[data-cb-slide]'));
  const dots = Array.from(root.querySelectorAll('[data-cb-dot]'));
  const previous = root.querySelector('[data-cb-prev]');
  const next = root.querySelector('[data-cb-next]');
  const pause = root.querySelector('[data-cb-pause]');
  const current = root.querySelector('[data-cb-current]');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let activeIndex = 0;
  let timer;
  let paused = reducedMotion;

  const render = (newIndex) => {
    activeIndex = (newIndex + slides.length) % slides.length;
    slides.forEach((slide, index) => {
      const active = index === activeIndex;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
    });
    dots.forEach((dot, index) => {
      const active = index === activeIndex;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    if (current) current.textContent = String(activeIndex + 1).padStart(2, '0');
  };

  const stop = () => {
    window.clearInterval(timer);
  };

  const play = () => {
    stop();
    if (!paused && slides.length > 1) timer = window.setInterval(() => render(activeIndex + 1), 7000);
  };

  if (previous) previous.addEventListener('click', () => {
      render(activeIndex - 1);
      play();
    });
  if (next) next.addEventListener('click', () => {
      render(activeIndex + 1);
      play();
    });
  dots.forEach((dot, index) => dot.addEventListener('click', () => {
    render(index);
    play();
  }));
  pause.addEventListener('click', () => {
    paused = !paused;
    root.classList.toggle('is-paused', paused);
    pause.setAttribute('aria-pressed', paused ? 'true' : 'false');
    pause.setAttribute('aria-label', paused ? 'Automatische Wiedergabe starten' : 'Automatische Wiedergabe pausieren');
    pause.textContent = paused ? '▶' : 'Ⅱ';
    play();
  });
  root.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft') {
      render(activeIndex - 1);
      play();
    }
    if (event.key === 'ArrowRight') {
      render(activeIndex + 1);
      play();
    }
  });
  root.addEventListener('mouseenter', stop);
  root.addEventListener('mouseleave', play);
  root.addEventListener('focusin', stop);
  root.addEventListener('focusout', play);
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) stop();
    else play();
  });
  root.dataset.cbInitialized = 'true';
  render(0);
  play();
};

const initCitybeeVideo = (root) => {
  if (root.dataset.cbVideoInitialized === 'true') return;
  const video = root.querySelector('video');
  const toggle = root.querySelector('[data-cb-video-toggle]');
  if (!video || !toggle) return;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let userPaused = reducedMotion;

  const attachSource = () => {
    if (video.dataset.cbLoaded === 'true') return;
    const hd = window.matchMedia('(min-width: 1024px)').matches;
    const src = (hd && video.dataset.cbSrcHd) || video.dataset.cbSrc;
    if (!src) return;
    video.src = src;
    video.dataset.cbLoaded = 'true';
  };

  const updateButton = () => {
    const paused = video.paused;
    toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
    toggle.setAttribute('aria-label', paused ? 'Video abspielen' : 'Video pausieren');
    toggle.querySelector('span').textContent = paused ? '▶' : 'Ⅱ';
  };

  const play = () => {
    if (userPaused) return;
    attachSource();
    const promise = video.play();
    if (promise) promise.catch(updateButton);
  };

  toggle.addEventListener('click', () => {
    if (video.paused) {
      userPaused = false;
      attachSource();
      play();
    } else {
      userPaused = true;
      video.pause();
    }
  });
  video.addEventListener('play', updateButton);
  video.addEventListener('pause', updateButton);

  if (reducedMotion) {
    video.pause();
  } else if ('IntersectionObserver' in window) {
    const preloader = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          attachSource();
          preloader.disconnect();
        }
      });
    }, { rootMargin: '600px 0px' });
    preloader.observe(root);
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) play();
        else video.pause();
      });
    }, { threshold: 0.18 });
    observer.observe(root);
  } else {
    attachSource();
    play();
  }

  root.dataset.cbVideoInitialized = 'true';
  updateButton();
};

const initCitybeeHome = () => {
  document.querySelectorAll('[data-cb-slider]').forEach(initCitybeeSlider);
  document.querySelectorAll('[data-cb-video]').forEach(initCitybeeVideo);
  document.querySelectorAll('.cb2').forEach((home) => {
    if (home.dataset.cbRevealInitialized === 'true') return;
    const items = home.querySelectorAll('[data-cb-reveal]');
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
    } else {
      home.classList.add('has-motion');
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });
      items.forEach((item) => observer.observe(item));
    }
    home.dataset.cbRevealInitialized = 'true';
  });
};

initCitybeeHome();
document.addEventListener('shopify:section:load', initCitybeeHome);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["citybee-image-preview"]) return;
  try {
    
  (() => {
    const assetRoot = '/cdn/shop/t/14/assets/';
    const heroImages = [
      null,
      null,
      'hero-mint-v8-mirrored.webp'
    ];
    const heroAlts = [
      'Mattschwarze Citybee Eiswürfelmaschine auf einem Getränkewagen in einer hellen europäischen Stadtwohnung zur blauen Stunde',
      'Edelstahlfarbene Citybee Eiswürfelmaschine auf einem ovalen Kalksteintisch in einer hellen europäschen Küche',
      'Mintgrüne Citybe Eiswürfelmaschine auf einem Metalltisch in einem sonnigen europäischen Stadthausgarten'
    ];
    const products = {
      'eiswurfelmaschine-fur-zuhause-und-buro-9-eiswurfel-in-6-minuten': {
        source: 'fe6cbd5b2fd49cedd5c543ab04d4d940.png',
        preview: 'product-studio-v2.webp'
      },
      'eiswurfelmaschine-kompakt-mit-tragegriff-eismaschine-fur-2-eisgrossen-12-kg-24-std-inkl-1-3-l-wassertank': {
        source: 'Variant_01.jpg',
        preview: 'product-compact-v3.webp'
      },
      'eiswurfelmaschine-mit-tragegriff-2-eiswurfelgrossen-12-kg-24-h': {
        source: '20.png',
        preview: 'product-move-v3.webp'
      },
      'eiswurfelmaschine-klein-2-elsgrossen-selbstreinigend-ice-maker-tragbar': {
        source: '3-1.jpg',
        preview: 'product-mint-v3.webp'
      },
      'eiswurfelmaschine-klein-2-elsgrossen-selbstreinigend-ice-maker-tragbar-1': {
        source: 'fe6cbd5b2fd49cedd5c543ab04d4d940_d91fab6c-a03a-4418-8307-4e1774f5ccaa.png',
        preview: 'product-black-v3.webp'
      }
    };

    const replaceImage = (image, filename) => {
      if (!image || image.dataset.citybeeImagePreview === filename) return;
      image.dataset.citybeeImagePreview = filename;
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = `${assetRoot}${filename}`;
      const picture = image.closest('picture');
      if (picture) {
        picture.querySelectorAll('source').forEach((source) => {
          source.removeAttribute('srcset');
        });
      }
    };

    const applyPreviewImages = () => {
      document.querySelectorAll('[data-cb-slide] img').forEach((image, index) => {
        if (!heroImages[index]) return;
        const slide = image.closest('[data-cb-slide]');
        if (slide) {
          slide.classList.add('citybee-v5-hero');
          slide.classList.remove('citybee-v7-light-copy');
          slide.classList.add('cb2-slide--rightcopy');
        }
        replaceImage(image, heroImages[index]);
        image.alt = heroAlts[index];
      });

      const productHandle = window.location.pathname.split('/products/')[1]?.split('/')[0];
      const currentProduct = products[productHandle];
      if (!currentProduct) return;

      document.querySelectorAll('main img').forEach((image) => {
        const sources = [
          image.currentSrc,
          image.src,
          image.getAttribute('srcset')
        ].filter(Boolean).join(' ');
        if (sources.includes(currentProduct.source)) {
          replaceImage(image, currentProduct.preview);
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applyPreviewImages, { once: true });
    } else {
      applyPreviewImages();
    }

    [300, 1000, 2500].forEach((delay) => {
      window.setTimeout(applyPreviewImages, delay);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
